module.exports = __webpack_public_path__ + "img/videocam.699d8215.svg";